module.exports = __webpack_public_path__ + "media/applicants/device_signup_5-779f2667.webp";